export default (state, { payload }) => ({
  ...state,
  items: payload
});
